/* eslint-disable camelcase */
import { Query, FormSchema } from '@fulcrumapp/query-sql';
import { Form } from '@fulcrumapp/fulcrum-core';
import { cloneDeep } from 'lodash';
import type { SortingExpression, SqlOptions } from '../types';
import type { TypedExpressions } from './filter-builder';
import filterBuilder from './filter-builder';
import sortingBuilder from './sorting-builder';

interface QueryAttributes {
  form: Form,
  schema: FormSchema,
  linkedForms?: Form[],
  search_filter?: string,
  filter?: TypedExpressions
  sorting?: SortingExpression[]
}

/**
 * Responsible for building a @fulcrumapp/query-sql Query object.
 * See https://docs.google.com/document/d/1CN7JsX6BcT7prR3FRe13kPbFqTZcOExMYWNNgEF9_WM/edit?usp=sharing
 *
 * @param sqlOptions
 * @returns Query
 */

export default function sqlBuilder(sqlOptions: SqlOptions): Query {
  const attrs = sqlBuilderAttributes(sqlOptions);
  return new Query(attrs);
}

export function sqlBuilderAttributes(sqlOptions: SqlOptions): QueryAttributes {
  const { restForm, queryColumns, recordFilters } = sqlOptions;
  const fulcrumCoreForm = new Form(restForm);
  const form = cloneDeep(fulcrumCoreForm);
  const filters = filterBuilder(sqlOptions);
  const sorting = sortingBuilder(sqlOptions);

  const attrs: QueryAttributes = {
    form,
    schema: new FormSchema(form, queryColumns.form, queryColumns.repeatables, {
      fullSchema: true,
    }),
  };

  if (recordFilters?.globalFilter) {
    attrs.search_filter = recordFilters?.globalFilter;
  }

  if (filters) {
    attrs.filter = filters;
  }

  if (sorting.length) {
    attrs.sorting = sorting;
  }

  return attrs;
}
